var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.00390625,
    width: 60,
    height: 60,
    rx: 4,
    fill: "#67829B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 28.0199C20.5 32.4952 24.1396 36.1257 28.6148 36.1257C30.4114 36.1257 32.0591 35.5405 33.4021 34.5442L38.6267 39.7821C38.8419 39.9922 39.1227 40.0984 39.4168 40.0984C40.0575 40.0984 40.5 39.6133 40.5 38.9929C40.5 38.698 40.3838 38.4302 40.1969 38.221L34.9903 33.0054C36.0746 31.6312 36.7165 29.9045 36.7165 28.0199C36.7165 23.5487 33.086 19.9092 28.6148 19.9092C24.1396 19.9092 20.5 23.5487 20.5 28.0199ZM22.0489 28.0199C22.0489 24.397 24.9878 21.4581 28.6148 21.4581C32.2287 21.4581 35.1766 24.397 35.1766 28.0199C35.1766 31.6379 32.2287 34.5858 28.6148 34.5858C24.9878 34.5858 22.0489 31.6379 22.0489 28.0199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionIcon);
export default __webpack_public_path__ + "static/media/inspection-icon.933a67817282b047fded0a1498e73a6b.svg";
export { ForwardRef as ReactComponent };